import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiService } from '@/api';
import {
    Document,
    DocumentsOptions,
    PaginatedResponse
} from '@/interfaces';

@Injectable({
    providedIn: 'root'
})
export class DocumentsService {

    constructor(private apiService: ApiService) {
    }

    listing(params: Record<string, any>): Observable<PaginatedResponse<Document>> {
        return this.apiService.get<any>('/documents', this.apiService.build(params)).pipe(
            map((res: any) => ({
                data: res.data,
                total: res.total,
                current_page: res.current_page,
                per_page: res.per_page
            }))
        );
    }

    export(params: Record<string, any>): Observable<Blob> {
        return this.apiService.postBlob('/documents/export', params);
    }

    options(context: Record<string, any> = {}): Observable<DocumentsOptions> {
        return this.apiService.get<DocumentsOptions>(
            '/documents/options',
            this.apiService.build(context)
        ).pipe(
            map(res => res.data ?? res)
        );
    }

    autocomplete(field: 'district_name', query: string, context: Record<string, any> = {}) {
        return this.apiService.get<string[]>(
            `/documents/autocomplete/${field}`,
            this.apiService.build({ q: query, ...context })
        );
    }
}
